/**
 * Global reducer for the Flux/Redux skeleton.
 */

import { createSlice } from '@reduxjs/toolkit';
import { fetchEntityCatalog } from '../actions/appThunks';
import { Entity } from '../../@types/entityCatalog';

export interface AppState {
    entityCatalog: {
        data: Entity;
        isLoading: boolean;
        error: string | null;
    }
};

const initialState: AppState = {
    entityCatalog: {
        data: {} as Entity,
        isLoading: false,
        error: null,
    }
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEntityCatalog.pending, (state) => {
                state.entityCatalog.isLoading = true;
                state.entityCatalog.error = null;
            })
            .addCase(fetchEntityCatalog.fulfilled, (state, action) => {
                state.entityCatalog.isLoading = false;
                state.entityCatalog.data = action.payload;
                state.entityCatalog.error = null;
            })
            .addCase(fetchEntityCatalog.rejected, (state, action) => {
                state.entityCatalog.isLoading = false;
                state.entityCatalog.error = action.error.message ?? 'Failed to fetch entity catalog';
            });
    },
});

export const appReducer = appSlice.reducer;